import { render, staticRenderFns } from "./modalPedidosCliente.vue?vue&type=template&id=62b742af"
import script from "./modalPedidosCliente.vue?vue&type=script&lang=js"
export * from "./modalPedidosCliente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports